import { BsFillBagDashFill } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import { FaCode, FaFileInvoiceDollar } from "react-icons/fa";
import { GiMoneyStack } from "react-icons/gi";
import { MdCampaign, MdOutlineSupportAgent } from "react-icons/md";
import { PiStudentFill } from "react-icons/pi";
import { TbWorldCode } from "react-icons/tb";
import { HiDocumentDownload, HiUserAdd } from "react-icons/hi";
import { SiWebtrees } from "react-icons/si";
import { IoMdPersonAdd } from "react-icons/io";
import {
  Building2,
  GalleryThumbnails,
  ScanLine,
  SwatchBook,
} from "lucide-react";
import { LiaAddressBook } from "react-icons/lia";
import { AiOutlineUserDelete } from "react-icons/ai";
import { FaPeopleArrows } from "react-icons/fa";
import { BiSolidShoppingBags } from "react-icons/bi";


export const sidebarRoutes = {
  user: [
    { path: "/", label: "Addmission Form", icon: <IoMdPersonAdd /> },
    {
      path: "/enquiry",
      label: "Web Enquiry",
      icon: <MdOutlineSupportAgent />,
      search: "?page=1",
    },
     {
      path: "/enquiry-mindverse",
      label: "Mindverse Enquiry",
      icon: <MdCampaign/>,
      search: "?page=1",
     },
    // {
    //   path: "/jmd",
    //   label: "JMD",
    //   icon: <BsMeta />,
    //   search: "?page=1",
    // },
    {
      path: "/visited-enquiries",
      label: "Visited Enquiries",
      icon: <FaPeopleArrows />,
    },
    // {
    //   path: "/online-visiting",
    //   label: "Online Visiting",
    //   icon: <RiBaseStationLine />,
    // },

    {
      path: "/students",
      label: "Enrolled Students",
      icon: <PiStudentFill />,
      search: "?page=1",
    },
    {
      path: "/docs",
      label: "Docs",
      icon: <HiDocumentDownload />,
      search: "?page=1",
    },
    // { path: "/drop-students", label: "Drop Students", icon: <AiOutlineUserDelete />, search: "?page=1" },
    {
      path: "/job",
      label: "Job Post",
      icon: <BsFillBagDashFill />,
      search: "?page=1",
    },
    {
      path: "/resume",
      label: "Resume",
      icon: <LiaAddressBook />,
      search: "?page=1",
    },
    // { path: "/salary-slip", label: "Salary Slip", icon: <FaFileInvoiceDollar /> },
    { path: "/blogs", label: "Blog", icon: <TbWorldCode />, search: "?page=1" },
    { path: "/project", label: "Project Enquiry", icon: <CgWebsite /> },
    { path: "/portfolio", label: "Portfolio", icon: <GalleryThumbnails /> },
    {
      path: "/summer-course",
      label: "Summer course",
      icon: <BiSolidShoppingBags />,
      search: "?page=1",
    },
    {
      path: "/certificate-scanner",
      label: "Certificate Scanner",
      icon: <ScanLine />,
      search: "?page=1",
    },
    {
      path: "/companies-details",
      label: "Companies Detail",
      icon: <Building2 />,
      search: "?page=1",
    },
  ],
  subuser: [
    { path: "/", label: "Addmission Form", icon: <IoMdPersonAdd /> },
    {
      path: "/enquiry",
      label: "Web Enquiries",
      icon: <MdOutlineSupportAgent />,
      search: "?page=1",
    },
    {
      path: "/visited-enquiries",
      label: "Visited Enquiries",
      icon: <FaPeopleArrows />,
    },
     {
      path: "/resume",
      label: "Resume",
      icon: <LiaAddressBook />,
      search: "?page=1",
    },
     {
      path: "/certificate-scanner",
      label: "Certificate Scanner",
      icon: <ScanLine />,
      search: "?page=1",
    },
        {
      path: "/companies-details",
      label: "Companies Details",
      icon: <Building2 />,
      search: "?page=1",
    },

    // {
    //   path: "/online-visiting",
    //   label: "Online Visiting",
    //   icon: <RiBaseStationLine />,
    // },
  ],
  admin: [
    { path: "/", label: "Addmission Form", icon: <IoMdPersonAdd /> },
    {
      path: "/enquiry",
      label: "Web Enquiries",
      icon: <MdOutlineSupportAgent />,
      search: "?page=1",
    },
     {
      path: "/enquiry-mindverse",
      label: "Mindverse Enquiry",
      icon: <MdCampaign/>,
      search: "?page=1",
     },
    // {
    //   path: "/jmd",
    //   label: "Direct Enquiries",
    //   icon: <BsMeta />,
    //   search: "?page=1",
    // },
    {
      path: "/visited-enquiries",
      label: "Visited Enquiries",
      icon: <FaPeopleArrows />,
    },
    // {
    //   path: "/online-visiting",
    //   label: "Online Enquiries",
    //   icon: <RiBaseStationLine />,
    // },

    {
      path: "/students",
      label: "Enrolled Students",
      icon: <PiStudentFill />,
      search: "?page=1",
    },
    {
      path: "/drop-students",
      label: "Drop Students",
      icon: <AiOutlineUserDelete />,
      search: "?page=1",
    },

    {
      path: "/fee-details",
      label: "Fee Details",
      icon: <GiMoneyStack />,
      search: "?page=1",
    },

    { path: "/batch", label: "Current Batches", icon: <SwatchBook /> },
    {
      path: "/docs",
      label: "Docs",
      icon: <HiDocumentDownload />,
      search: "?page=1",
    },
    {
      path: "/resume",
      label: "Resume",
      icon: <LiaAddressBook />,
      search: "?page=1",
    },
    {
      path: "/salary-slip",
      label: "Salary Slip",
      icon: <FaFileInvoiceDollar />,
    },

    {
      path: "/certificate-scanner",
      label: "Certificate Scanner",
      icon: <ScanLine />,
      search: "?page=1",
    },
    {
      path: "/companies-details",
      label: "Companies Details",
      icon: <Building2 />,
      search: "?page=1",
    },
    // {
    //   path: "/job",
    //   label: "Job Post",
    //   icon: <BsFillBagDashFill />,
    //   search: "?page=1",
    // },
    // { path: "/certificate", label: "Generate Certificate", icon: <MdOutlineDocumentScanner /> },
    { path: "/project", label: "Project Enquiry", icon: <CgWebsite /> },
    {
      path: "/summer-course",
      label: "Summer course",
      icon: <BiSolidShoppingBags />,
      search: "?page=1",
    },
    {
      path: "/hackathon",
      label: "Hackathon Registrations",
      icon: <FaCode />,
      search: "?page=1",
    },
    {
      path: "/webinar",
      label: "Webinar",
      icon: <SiWebtrees />,
      search: "?page=1",
    },
    { path: "/add-user", label: "Add User", icon: <HiUserAdd /> },
    // { path: "/online-admission", label: "Online Admission", icon: <TbWorldCode />, search: "?page=1" },
    // { path: "/create-webinar", label: "Create Webinar", icon: <GrPersonalComputer /> },
    { path: "/portfolio", label: "Portfolio", icon: <GalleryThumbnails /> },
  ],
  superadmin: [
    { path: "/", label: "Addmission Form", icon: <IoMdPersonAdd /> },
    {
      path: "/enquiry",
      label: "Web Enquiries",
      icon: <MdOutlineSupportAgent />,
      search: "?page=1",
    },
     {
      path: "/enquiry-mindverse",
      label: "Mindverse Enquiry",
      icon: <MdCampaign/>,
      search: "?page=1",
     },
    // {
    //   path: "/jmd",
    //   label: "Direct Enquiries",
    //   icon: <BsMeta />,
    //   search: "?page=1",
    // },
    {
      path: "/visited-enquiries",
      label: "Visited Enquiries",
      icon: <FaPeopleArrows />,
    },
    // {
    //   path: "/online-visiting",
    //   label: "Online Enquiries",
    //   icon: <RiBaseStationLine />,
    // },

    {
      path: "/students",
      label: "Enrolled Students",
      icon: <PiStudentFill />,
      search: "?page=1",
    },
    {
      path: "/drop-students",
      label: "Drop Students",
      icon: <AiOutlineUserDelete />,
      search: "?page=1",
    },
    {
      path: "/fee-details",
      label: "Fee Details",
      icon: <GiMoneyStack />,
      search: "?page=1",
    },
    { path: "/batch", label: "Current Batches", icon: <SwatchBook /> },
    {
      path: "/docs",
      label: "Docs",
      icon: <HiDocumentDownload />,
      search: "?page=1",
    },

    {
      path: "/resume",
      label: "Resume",
      icon: <LiaAddressBook />,
      search: "?page=1",
    },
    {
      path: "/salary-slip",
      label: "Salary Slip",
      icon: <FaFileInvoiceDollar />,
    },
    {
      path: "/certificate-scanner",
      label: "Certificate Scanner",
      icon: <ScanLine />,
      search: "?page=1",
    },
    {
      path: "/companies-details",
      label: "Companies Detail",
      icon: <Building2 />,
      search: "?page=1",
    },
    // {
    //   path: "/job",
    //   label: "Job Post",
    //   icon: <BsFillBagDashFill />,
    //   search: "?page=1",
    // },
    // { path: "/certificate", label: "Generate Certificate", icon: <MdOutlineDocumentScanner /> },
    { path: "/project", label: "Project Enquiry", icon: <CgWebsite /> },
    {
      path: "/summer-course",
      label: "Summer course",
      icon: <BiSolidShoppingBags />,
      search: "?page=1",
    },

    {
      path: "/hackathon",
      label: "Hackathon Registrations",
      icon: <FaCode />,
      search: "?page=1",
    },
    {
      path: "/webinar",
      label: "Webinar",
      icon: <SiWebtrees />,
      search: "?page=1",
    },
    { path: "/add-user", label: "Add User", icon: <HiUserAdd /> },
    // { path: "/blogs", label: "Blog", icon: <TbWorldCode />, search: "?page=1" },
    // { path: "/create-webinar", label: "Create Webinar", icon: <GrPersonalComputer /> },
    // { path: "/online-admission", label: "Online Admission", icon: <TbWorldCode />, search: "?page=1" },
    { path: "/portfolio", label: "Portfolio", icon: <GalleryThumbnails /> },
  ],
};
